import React, { useMemo } from 'react';

const PIECE_COUNT = 28;

function buildPieces(seed) {
    return Array.from({ length: PIECE_COUNT }, (_, index) => ({
        id: `confetti-${seed}-${index}`,
        left: 8 + ((index * 17) % 84),
        delay: (index % 7) * 45,
        duration: 1400 + (index % 5) * 120,
        rotate: (index * 41) % 360,
        tone: index % 4,
    }));
}

/**
 * Lightweight CSS confetti for the result overlay.
 * @param {{ active: boolean }} props
 */
export function GameConfetti({ active }) {
    const seed = useMemo(() => (active ? Date.now() : 0), [active]);
    const pieces = useMemo(() => (active ? buildPieces(seed) : []), [active, seed]);

    if (!active || !pieces.length) return null;

    return (
        <div className="lp-game__confetti" aria-hidden>
            {pieces.map((piece) => (
                <span
                    key={piece.id}
                    className={`lp-game__confetti-piece lp-game__confetti-piece--${piece.tone}`}
                    style={{
                        left: `${piece.left}%`,
                        animationDelay: `${piece.delay}ms`,
                        animationDuration: `${piece.duration}ms`,
                        '--lp-confetti-rotate': `${piece.rotate}deg`,
                    }}
                />
            ))}
        </div>
    );
}
